import { createSelector } from "reselect";

import { getDeadlinesCount } from "buyer_portal/selectors/deadlines";
import { getProjectSlug } from "shared/selectors/project";
import { getBaseUnit, getUnitCount } from "shared/selectors/unit/unit";
import { getUser } from "shared/selectors/base";
import hasAttachments from "../../buyer_portal/selectors/attachments";

export const getPageMenu = createSelector(
  [
    getBaseUnit,
    getUnitCount,
    getProjectSlug,
    getUser,
    getDeadlinesCount,
    hasAttachments
  ],
  (unit, unitCount, projectSlug, user, deadlinesCount, attachments) => {
    const items = [];
    const hasMultipleUnits = unitCount > 1;
    const hasUnit = unit && projectSlug;

    if (hasMultipleUnits) {
      items.push({
        id: "units",
        link: `/`,
        message: "buyerPortal.menu.units"
      });
    }

    if (hasUnit) {
      if (!unit.sample) {
        [
          {
            id: "products",
            link: `/${projectSlug}/unit/${unit.slug}`,
            message: "buyerPortal.menu.products"
          },
          {
            id: "deadlines",
            link: `/${projectSlug}/unit/${unit.slug}/deadlines`,
            message: "buyerPortal.menu.deadlines",
            hidden: deadlinesCount < 1
          },
          {
            id: "attachments",
            link: `/${projectSlug}/unit/${unit.slug}/attachment`,
            message: "buyerPortal.menu.attachments"
          },
          {
            id: "orderStatus",
            link: `/${projectSlug}/unit/${unit.slug}/order-status`,
            message: "buyerPortal.menu.orderStatus"
          }
        ].forEach(i => {
          items.push(i);
        });
      }

      if (unit.sample) {
        items.push({
          id: "description",
          link: `/${projectSlug}/musterwohnung/${unit.sample_unit_token}`,
          message: unit.description
        });
        if (attachments) {
          items.push({
            id: "attachments",
            link: `/${projectSlug}/musterwohnung/${unit.sample_unit_token}/attachment`,
            message: "buyerPortal.menu.attachments"
          });
        }
      }
    }

    if (user) {
      items.push({
        id: "logout",
        action: "logoutAction",
        icon: {
          name: "shutdown"
        },
        message: "buyerPortal.menu.logout"
      });
    }

    return items.filter(i => !i.hidden);
  }
);
